import { COMMON_VALUES, SEARCH_TEMP, RESPONSE_STATUS, CLEAR_RESPONSE } from './commonTypes'

export default (state, action) => {
    switch (action.type) {
        case COMMON_VALUES:
            return {
                ...state,
                ...action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case SEARCH_TEMP:
            return {
                ...state,
                searchTempValue: action.payload,
            }
        default:
            return state
    }
}
